<template>
  <div>
    <div class="card box-shadow-1 mb-4">
      <div class="card-body">
        <div class="mb-3 d-flex align-content-center">
          <img
            src="./../../../assets/images/icons8_price-tag.svg"
            class="mr-2"
          />
          {{ $t("price_summary") }}
        </div>
        <div
          class="d-flex align-items-center justify-content-between col-gap-1 mb-3"
        >
          <span class="gray4"> {{ $t("item") }}</span>
          <span class="">{{ displayedPrice }}</span>
        </div>
        <div
          class="d-flex align-items-center justify-content-between col-gap-1 mb-3"
          v-if="insurancePlan.plan"
        >
          <span class="gray4"> {{ $t("Insurance Fee") }}</span>
          <span class="">{{ formattedTotalPrice(insurancePlan.amount) }}</span>
        </div>
        <hr class="mb-3 gray4" />
        <div
          class="d-flex align-items-center justify-content-between col-gap-1"
        >
          <span class=""> {{ $t("total") }}</span>
          <span class="font-bold">{{ displayedTotal }}</span>
        </div>
      </div>
    </div>
    <div class="card box-shadow-1 mb-4">
      <div class="card-body">
        <p class="mb-3">{{ $t("pickup_deets") }}</p>

        <div class="table-responsive">
          <div
            id="zero_config_wrapper"
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="row" style="height: 8rem; overflow: auto">
              <div class="col-sm-12">
                <table id="zero_config" class="table">
                  <thead class="data-table-bg">
                    <tr>
                      <th
                        :key="index"
                        v-for="(label, index) in tableColumns"
                        style="cursor: pointer; text-align: left"
                      >
                        {{ label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :key="`${index}`"
                      v-for="(data, index) in pickupDetails"
                      style="cursor: pointer; text-align: left"
                      :class="{
                        'data-table-bg': index % 2 !== 0,
                      }"
                    >
                      <td>{{ data.name }}</td>
                      <td>{{ data.companyName }}</td>
                      <td>{{ data.phoneNumber }}</td>
                      <td>
                        {{ data.email }}
                      </td>
                      <td>
                        {{ data.address }}
                      </td>
                      <td>
                        {{ data.notes }}
                      </td>
                      <td>
                        <div class="d-flex align-items-center col-gap-1">
                          <span
                            class="cursor-pointer"
                            @click="$emit('edit_pickup', data)"
                          >
                            <IconEdit />
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card box-shadow-1">
      <div class="card-body">
        <p class="mb-3">{{ $t("item_dropoff") }}</p>

        <div class="table-responsive">
          <div
            id="zero_config_wrapper"
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="row" style="height: 15rem; overflow: auto">
              <div class="col-sm-12">
                <!-- <table id="zero_config" class="table">
                  <thead class="data-table-bg">
                    <tr>
                      <th
                        :key="index"
                        v-for="(label, index) in itemDropOffCols"
                        style="cursor: pointer; text-align: left"
                      >
                        {{ label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="({ contact, items }, index) in dropOffs">
                      <tr
                        :key="`dropoff-${index}`"
                        style="cursor: pointer; text-align: left"
                        :class="{
                          'data-table-bg': index % 2 !== 0,
                        }"
                        v-if="items.length"
                      >
                        <td>{{ formatDate(items[0].deliveryDate) }}</td>
                        <td>{{ items[0].name }}</td>
                        <td>{{ items[0].weight }}</td>
                        <td>{{ items[0].quantity }}</td>
                        <td>{{ items[0].price }}</td>
                        <td>
                          {{ items[0].description }}
                        </td>
                        <td style="width: 8rem">
                          <div class="d-flex align-items-center col-gap-1">
                            <span
                              class="cursor-pointer"
                              @click="toggleAccordion(index)"
                            >
                              <DropdownIcon
                                v-if="index === expandedIndex"
                                style="transform: rotate(180deg)"
                              />
                              <DropdownIcon v-else />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="$emit('edit_item', items[0], index)"
                            >
                              <IconEdit />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="handleDeleteItem(items[0], items, index)"
                            >
                              <IconDeleteUser />
                            </span>
                          </div>
                        </td>
                      </tr>
                      <template v-if="showError && errorIndex === index">
                        <tr :key="'error-' + index">
                          <td colspan="7" class="p-0">
                            <div
                              class="d-flex justify-content-center align-items-center"
                            >
                              <div
                                class="cursor-pointer d-flex justify-content-center align-items-center"
                                @click="$emit('showAddItemModal')"
                              >
                                <p class="mb-0 font-12 text-error">
                                  {{ $t("error_summary") }}
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </template>
                      <transition-group
                        name="slide-fade"
                        v-if="contact.name"
                        :key="'accordion-' + index"
                        style="display: contents"
                      >
                        <template v-if="expandedIndex === index">
                          <tr
                            v-for="(item, itemIndex) in itemsData(items)"
                            :key="`item-${itemIndex}`"
                            style="cursor: pointer; text-align: left"
                            :class="{
                              'data-table-bg': itemIndex % 2 === 0,
                            }"
                          >
                            <td>{{ formatDate(item.deliveryDate) }}</td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.weight }}</td>
                            <td>{{ item.quantity }}</td>
                            <td>{{ item.price }}</td>
                            <td>{{ item.description }}</td>
                            <td style="width: 8rem">
                              <div
                                class="d-flex align-items-center col-gap-1 justify-content-end"
                              >
                                <span
                                  class="cursor-pointer"
                                  @click="$emit('edit_item', item)"
                                >
                                  <IconEdit />
                                </span>
                                <span
                                  class="cursor-pointer"
                                  @click="
                                    handleDeleteItem(item, items, index + 2)
                                  "
                                >
                                  <IconDeleteUser />
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr :key="`contact_${index}`">
                            <td colspan="7" class="px-0 pt-0">
                              <table id="zero_config" class="table">
                                <thead
                                  :class="{
                                    'data-table-bg': index % 2 !== 0,
                                  }"
                                >
                                  <tr>
                                    <th
                                      :key="index"
                                      v-for="(
                                        column, index
                                      ) in tableColumnsContact"
                                      style="cursor: pointer; text-align: left"
                                    >
                                      {{ column }}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    style="cursor: pointer; text-align: left"
                                    :class="{
                                      'data-table-bg': index % 2 !== 0,
                                    }"
                                    :key="index"
                                    v-if="contact.name"
                                  >
                                    <td>{{ contact.name }}</td>
                                    <td>{{ contact.email }}</td>
                                    <td>{{ contact.phoneNumber }}</td>
                                    <td>{{ items.length }}</td>
                                    <td>{{ contact.address }}</td>
                                    <td>
                                      <div
                                        class="d-flex align-items-center col-gap-1"
                                      >
                                        <span
                                          class="cursor-pointer"
                                          @click="
                                            $emit(
                                              'edit_dropOff',
                                              { contact, items },
                                              index
                                            )
                                          "
                                        >
                                          <IconEdit />
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </template>
                      </transition-group>
                    </template>
                  </tbody>
                </table> -->

                <!-- table 2 -->

                <table id="order-listing" class="table display">
                  <thead style="background-color: rgba(240, 244, 251, 0.6)">
                    <tr class="data-table-bg">
                      <th
                        :key="index"
                        v-for="(column, index) in receiverTableColumns"
                        style="cursor: pointer; text-align: left"
                      >
                        {{ column[0] }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="({ items, contact }, index) in dropOffs">
                      <tr
                        :key="index"
                        class="user-row"
                        style="border-bottom: unset"
                        :class="{
                          'data-table-bg': index % 2 !== 0,
                        }"
                      >
                        <td>{{ contact.name }}</td>
                        <td>{{ contact.email }}</td>
                        <td>{{ contact.phoneNumber }}</td>
                        <td>{{ items.length }}</td>
                        <td>{{ contact.address }}</td>
                        <td>
                          <div class="d-flex align-items-center col-gap-1">
                            <span
                              class="cursor-pointer"
                              @click="toggleAccordion(index)"
                            >
                              <DropdownIcon
                                v-if="index === expandedIndex"
                                style="transform: rotate(180deg)"
                              />
                              <DropdownIcon v-else />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="
                                $emit('edit_dropOff', { contact, items }, index)
                              "
                            >
                              <IconEdit />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="$emit('delete_dropOff', index)"
                            >
                              <IconDeleteUser />
                            </span>
                            <!-- <span
                              class="cursor-pointer"
                              @click="handleDeleteItem(items[0], items, index)"
                            >
                              <IconDeleteUser />
                            </span> -->
                          </div>
                        </td>

                        <!-- <td style="width: 8rem">
                          <div class="d-flex align-items-center col-gap-1">
                            <span
                              class="cursor-pointer"
                              @click="toggleAccordion(index)"
                            >
                              <DropdownIcon
                                v-if="index === expandedIndex"
                                style="transform: rotate(180deg)"
                              />
                              <DropdownIcon v-else />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="$emit('edit_item', items[0], index)"
                            >
                              <IconEdit />
                            </span>
                            <span
                              class="cursor-pointer"
                              @click="handleDeleteItem(items[0], items, index)"
                            >
                              <IconDeleteUser />
                            </span>
                          </div>
                        </td> -->
                      </tr>
                      <transition name="slide-fade" :key="'accordion-' + index">
                        <tr v-if="expandedIndex === index">
                          <td colspan="6" class="px-0 pt-0">
                            <table class="nested-table w-100">
                              <thead class="data-table-bg">
                                <tr>
                                  <th
                                    :key="index"
                                    v-for="(column, index) in tableColumnsItems"
                                    style="cursor: pointer; text-align: left"
                                  >
                                    {{ column[0] }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in items"
                                  :key="item.name + item.deliveryDate"
                                >
                                  <td>{{ formatDate(item.deliveryDate) }}</td>
                                  <td>{{ item.name }}</td>
                                  <td>{{ item.weight }}</td>
                                  <td>{{ item.quantity }}</td>
                                  <td>{{ item.logisticsType }}</td>
                                  <td>{{ formattedTotalPrice(item.price) }}</td>
                                  <td>{{ item.description }}</td>
                                  <td>
                                    {{ item.dataLoggerSettings.minTemperature }}
                                  </td>
                                  <td>
                                    {{ item.dataLoggerSettings.maxTemperature }}
                                  </td>
                                  <td>
                                    {{ item.dataLoggerSettings.minHumidity }}
                                  </td>
                                  <td>
                                    {{ item.dataLoggerSettings.maxHumidity }}
                                  </td>
                                  <td style="width: 8rem">
                                    <div
                                      class="d-flex align-items-center col-gap-1"
                                    >
                                      <span
                                        class="cursor-pointer"
                                        @click="$emit('edit_item', item, index)"
                                      >
                                        <IconEdit />
                                      </span>
                                      <span
                                        class="cursor-pointer"
                                        @click="
                                          handleDeleteItem(item, items, index)
                                        "
                                      >
                                        <IconDeleteUser />
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </transition>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DropdownIcon from "../../../components/Iconsvg/DropdownIcon.vue";
import IconDeleteUser from "../../../components/Iconsvg/IconDeleteUser.vue";
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";
import { currenciesFormat } from "../../../utils/constants";

export default {
  name: "Summary",
  components: {
    IconDeleteUser,
    IconEdit,
    DropdownIcon,
  },
  props: {
    dropOffs: Array,
    pickupDetails: Array,
    summaryPrices: {
      type: Object,
      default: () => ({
        totalItemsPrice: "",
        total: "",
        vatAmount: "",
      }),
    },
    currency: String,
    insurancePlan: Object,
    productWorth: Number,
    totalItemsPrice: Number,
  },
  data() {
    return {
      // tableColumns,
      // itemDropOffCols,
      expandedIndex: null,
      // tableColumnsContact,
      showError: false,
      errorIndex: null,
      tableColumnsItems: [
        [this.$t("Date & Time"), "date"],
        [this.$t("Name"), "name"],
        [this.$t("Wgt"), "weight"],
        [this.$t("Qty"), "quantity"],
        [this.$t("Logistics"), "logistics"],
        [this.$t("price"), "price"],
        [this.$t("description"), "description"],
        ["Min Temp", "minTemp"],
        ["Max Temp", "maxTemp"],
        ["Min Humd", "minHumd"],
        ["Max Humd", "maxHumd"],
        [this.$t("action"), "column2"],
      ],
      receiverTableColumns: [
        [this.$t("reciever_name"), "column1"],
        [this.$t("email"), "column2"],
        [this.$t("phone_num"), "column3"],
        ["No of Items", "column4"],
        [this.$t("address"), "column5"],
        // ["Status", "column6"],
        [this.$t("actions"), "column7"],
      ],

      tableColumns: [
        this.$t("sender"),
        this.$t("company"),
        this.$t("phone_no"),
        this.$t("email"),
        this.$t("address"),
        this.$t("notes1"),
        this.$t("actions"),
      ],
    };
  },
  methods: {
    formattedPrice(price) {
      if (!price) return "calculating...";
      return new Intl.NumberFormat(currenciesFormat[this.currency], {
        style: "currency",
        currency: this.currency,
      }).format(price);
    },
    toggleAccordion(index) {
      this.expandedIndex = this.expandedIndex === index ? null : index;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YY HH:mm");
    },
    itemsData(items) {
      const newItems = [...items];
      newItems.shift();
      return newItems;
    },
    handleDeleteItem(item, items, index) {
      if (items.length === 1) {
        this.showError = true;
        this.errorIndex = index;
      } else return this.$emit("delete_item", item);
    },
    formattedTotalPrice(amount) {
      return new Intl.NumberFormat(currenciesFormat[this.currency], {
        style: "currency",
        currency: this.currency,
      }).format(amount);
    },
  },

  watch: {
    showError(val) {
      if (val) {
        setTimeout(() => {
          this.showError = false;
          this.errorIndex = null;
        }, 4000);
      }
    },
  },
  mounted() {
    console.log(this.insurancePlan);
  },
  computed: {
    totalPlusDispatchPrice() {
      let total = 0;
      if (this.insurancePlan.plan) {
        total = this.totalProductPrice + this.insurancePlan.amount;
      } else {
        total = this.totalProductPrice;
      }
      return total;
    },
    totalProductPrice() {
      return this.productWorth || this.totalItemsPrice;
    },
    displayedPrice() {
      return this.totalProductPrice
        ? this.formattedPrice(this.totalProductPrice)
        : "N/A";
    },
    displayedTotal() {
      return this.totalPlusDispatchPrice
        ? this.formattedPrice(this.totalPlusDispatchPrice)
        : "N/A";
    },
  },
};
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-20px);
}
</style>
